/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect } from "react";
import cn from "clsx";
import { isTrue } from "cms/utils/empty-exists";
import { useSimpliCityPath } from "cms/webpage/use-simplicity-path";

const EmbedComponent = (props) => {

    const component = props?.component;
    const { path } = useSimpliCityPath();
    const html = component?.html;
    const isResponsive = component?.isResponsive;
    const enableScript = component?.enableScript;
    const _script = component?.script;
    const unload_script = component?.unload_script;
    const hasContent = html !== "/*<!-- SimpliCity CMS Embed placeholder -->*/\n";
    const classNames = cn("simplicity-embed", { "responsive": isResponsive });
    const hasUnloadScript = unload_script?.length > 0;

    useEffect(() => {
        if (isTrue(enableScript)) {
            window.eval(_script);
            console.log("init embed script");
        } else {
            console.log("not init embed script");
        }
        return () => {
            if (hasUnloadScript) {
                console.log("unload script");
                window.eval(unload_script);
            } else {
                console.log("no unload script");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_script, path]);

    return (
        <>
            {hasContent &&
                <div className={classNames} id='embed-container'>
                    <div dangerouslySetInnerHTML={{ __html: html }} />
                </div>
            }
        </>
    );
};

EmbedComponent.displayName = "EmbedComponent";
export { EmbedComponent };
